export default "__VITE_ASSET__C2XfzS4V__"